import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { of } from "rxjs";
import { ApiResponse } from "../../models/common.model";
import { loadNews, loadNewsFailure, loadNewsSuccess } from "./news.action";
import { CustomerService } from "../../services/customer.service";
import { AuthServiceService } from "../../services/auth-service.service";

@Injectable()
export class NewsEffects {
  constructor(private actions$: Actions, private auth: AuthServiceService) { }

  // Effect to load News products
  loadNews$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadNews),
      switchMap((action: { adminId: any; isAdmin?: any; page?: any; isPopular?: any; category?: any; hashtag?: any; pageSize?: any }) =>
        this.auth.get_bottom_banner({
          adminId: action.adminId,
          isAdmin: action.isAdmin,
          page: action.page,
          isPopular: action.isPopular,
          category: action.category,
          hashtag: action.hashtag,
          pageSize: action.pageSize,
        }).pipe(
          map((response: ApiResponse) => {
            return loadNewsSuccess({ news: response.body });
          }),
          catchError((error) =>
            of(
              loadNewsFailure({
                error: {
                  message: error.message || "An unknown error occurred",
                  statusCode: error.status || 500,
                },
              })
            )
          )
        )
      )
    )
  );
}
